import { render, staticRenderFns } from "./editPaper.vue?vue&type=template&id=c7414f2c&scoped=true&"
import script from "./editPaper.vue?vue&type=script&lang=js&"
export * from "./editPaper.vue?vue&type=script&lang=js&"
import style0 from "./editPaper.vue?vue&type=style&index=0&id=c7414f2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7414f2c",
  null
  
)

export default component.exports